module.exports = __webpack_public_path__ + "img/p02.f46c729e.jpeg";